<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">new shippingline</small>
      </legend>
      <div>
        <form @submit.prevent="newShippingline()">
          <div class="form-group">
            <label>Shipping line</label>
            <input
              type="text"
              class="form-control shipping_name input-rounded f-s-14"
              placeholder="shipping line"
              required
            />
          </div>
          <div class="form-group">
            <label>Free days</label>
            <input
              type="number"
              class="form-control free_days input-rounded f-s-14"
              placeholder="free days"
              required
            />
          </div>

          <div class="form-group">
            <label>OOG days</label>
            <input
              type="number"
              class="form-control oog input-rounded f-s-14"
              placeholder="oog days"
              required
            />
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingShippingline btn-rounded">
            <i class="fa fa-ship"></i> create shippingline
          </button>
          <button type="button" class="btn btn-info btn-flat creatingShippinglineLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import $ from "jquery";
export default {
  created() {},

  methods: {
    ...mapActions(["newShippingline"])
  }
};
</script>
<style scoped>
.creatingShippinglineLoader {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/shippinglines/shippingline.vue